import { SetNewPasswordTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const SetNewPasswordTrackingSchema: Record<
  SetNewPasswordTrackingPoint,
  string
> = {
  [SetNewPasswordTrackingPoint.PageView]: '',
  [SetNewPasswordTrackingPoint.OkButtonClick]: '',
  [SetNewPasswordTrackingPoint.BackButtonClick]: '',
  [SetNewPasswordTrackingPoint.HelpButtonClick]: '',
  [SetNewPasswordTrackingPoint.SetPasswordSuccessAction]: '',
};

export const getSetNewPasswordPageTypeAndSchema = (
  trackingPoint: SetNewPasswordTrackingPoint
) => {
  return {
    page_type: PageType.SetNewPasswordPage,
    schema: SetNewPasswordTrackingSchema[trackingPoint],
  };
};
